<template>
  <ul class="ff-progressbar">
    <li :class="this.stats.signups_open_status">SIGNUPS OPEN</li>
    <li :class="this.stats.event_confirmed_status">EVENT CONFIRMED</li>
    <li :class="this.stats.all_groups_fired_status" v-if="this.stats.number_of_groups > 1">ALL GROUPS FIRED</li>
    <li :class="this.stats.filled_to_capacity_status">ALL SEATS FILLED</li>
  </ul>
</template>

<script>
export default {
  name: "QueueStatusOrbs",
  props: ["stats"]
}
</script>